export default __webpack_public_path__ + "media/images/icon_tel_fix-340f4faa67ae406b88cc384ad08b85b9.png";